import { cn } from '@/shadcn/lib/utils';

type Props = {
  className?: string;
};

// Read-only "Production" pill (no workspace selected / production data).
// Shared by the workspace filter (trigger + dropdown) and the read-only header.
export const ProductionBadge = ({ className }: Props) => (
  <span
    className={cn(
      'inline-flex h-5 shrink-0 items-center rounded-full bg-destructive px-3 text-destructive-foreground text-xs',
      className
    )}
  >
    Production
  </span>
);
